export const VARIANT_RENDERED_PROPS = {
  stickyBar: ['priceHTML', 'tooltipHTML', 'priceFromLabel'],
};
